module.exports = __webpack_public_path__ + "img/zoutao.d578dbad.jpg";